/* ─── Root ─── */

.root {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-sans);
}

/* ─── Linear track ─── */

.track {
  flex: 1;
  height: 8px;
  background: var(--md-primary-container);
  border-radius: var(--shape-full);
  overflow: hidden;
}

.indicator {
  height: 100%;
  background: var(--md-primary);
  border-radius: var(--shape-full);
  transition: width var(--motion-duration-medium1) var(--motion-easing-standard);
}

/* ─── Linear indeterminate ─── */

.root[data-state="indeterminate"] .indicator {
  width: 50% !important;
  animation: indeterminate 1.5s ease-in-out infinite;
}

@keyframes indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(300%);
  }
}

/* ─── Circular ─── */

.circular {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.circular.sm {
  width: 24px;
  height: 24px;
}

.circular.md {
  width: 40px;
  height: 40px;
}

.circular.lg {
  width: 64px;
  height: 64px;
}

.circularSvg {
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
}

.circularTrack {
  fill: none;
  stroke: var(--md-surface-container-highest);
  stroke-width: 4;
}

.circularIndicator {
  fill: none;
  stroke: var(--md-primary);
  stroke-width: 4;
  stroke-linecap: round;
  transition: stroke-dashoffset var(--motion-duration-medium1)
    var(--motion-easing-standard);
}

/* ─── Circular indeterminate ─── */

.root[data-state="indeterminate"] .circularSvg {
  animation: circularRotate 1.4s linear infinite;
}

.root[data-state="indeterminate"] .circularIndicator {
  animation: circularDash 1.4s ease-in-out infinite;
  stroke-dasharray: 80, 125.66;
  stroke-dashoffset: 0;
}

@keyframes circularRotate {
  100% {
    transform: rotate(270deg);
  }
}

@keyframes circularDash {
  0% {
    stroke-dasharray: 1, 125.66;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 80, 125.66;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 80, 125.66;
    stroke-dashoffset: -125;
  }
}

/* ─── Value text ─── */

.value {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  color: var(--md-on-surface-variant);
  white-space: nowrap;
}

.circularValue {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  position: absolute;
  color: var(--md-on-surface-variant);
}
